import { render } from "./patient_doc_med_page.vue?vue&type=template&id=45188892"
import script from "./patient_doc_med_page.vue?vue&type=script&lang=js"
export * from "./patient_doc_med_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__